// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCaseSurveyResponseModel {
    static getAttributeTypeMap() {
        return GetCaseSurveyResponseModel.attributeTypeMap;
    }
}
GetCaseSurveyResponseModel.discriminator = undefined;
GetCaseSurveyResponseModel.additionalProperties = false;
GetCaseSurveyResponseModel.attributeTypeMap = [
    {
        "name": "sessionData",
        "baseName": "sessionData",
        "type": "CaseSessionModel"
    },
    {
        "name": "valueData",
        "baseName": "valueData",
        "type": "Array<SurveySessionValueReadModel>"
    },
];
//# sourceMappingURL=getCaseSurveyResponseModel.js.map